export const DATASET_VISUAL_TAGS_LABELS = {
    's3 path': 'S3 path',
    'DB type': 'Dataset type',
    'Training Scheme': 'Training Scheme',
    'Seperator': 'Seperator',
    'Remove Duplicates': 'Remove Duplicates',
    'Smiles column': 'Smiles Column',
    'IDColumn': 'ID Column',
    'Fuzzy labeling': 'Fuzzy Labeling',
    'TARGET_ENR_threshold': 'Target ENR Threshold',
    'TARGET_RATIO_threshold': 'Target Ratio Threshold',
    'NTC_ENR_threshold': 'NTC ENR Threshold',
    'COMPETITOR_ENR_threshold': 'Competitor ENR Threshold',
    'Subsampling': 'Subsampling',
}

export const DATASET_RULES_FIELD_NAME = "Rules"

export const DATASET_RULES_NAMES = [
    "PTE Def",
    "NTE 1 Def",
    "NTE 2 Def",
    "NTE 3 Def",
    "NTE 4 Def",
]

export const DATASET_SMILES_COLUMN_NAME = "SMILES"